import React from "react";
import { connect } from "react-redux";
import classNames from "classnames";
import styled from "styled-components";
import { FaWindowClose } from "react-icons/fa";

import { COMPANY_SEARCH_RESET, COMPANY_SEARCH_SELECTED } from "actions";

const SelectCountryA = styled.a`
  background-color: ${props => props.bg} !important;
  border: 1px solid ${props => props.bg} !important;
  &:hover {
    background-color: transparent !important;
    cursor: pointer;
    color: ${props => props.bg} !important;
  }
`;

const CompanyItem = props => {
  const selectCompany = () => {
    props.select(props.company);
  };

  const { baseColour, selectText } = props;
  const { Title, Address, Name } = props.company;

  //build addressString
  let address = "";

  if (Address) {
    switch (typeof Address) {
      case "string":
        address = Address;
        break;
      case "object":
        const { Premises, AddressLine1, Locality, Country, PostalCode } = Address;
        address = (
          <span>
            {Premises} {AddressLine1}
            {", "}
            {Locality}
            {", "}
            {Country !== null && Country + ", "}
            {PostalCode}
          </span>
        );
        break;
      default:
        break;
    }
  
  }

  const className = `select test_companySearchSelectBtn${props.index}`;

  return (
    <div className="item">
      <SelectCountryA bg={baseColour} onClick={selectCompany} className={className}>
        {selectText}
      </SelectCountryA>
      <h5 className="item-bussines-name">{typeof Address === "string" ? Name : Title}</h5>
      <p style={{ paddingRight: 15 }}>{address}</p>
    </div>
  );
};

const CompanySearch = props => {
  const companySearchReset = () => {
    props.resetCompanySearch(props.companySearchFromTab);
  };

  const companySearchTryAgain = () => {
    props.resetCompanySearch(props.companySearchFromTab, true);
  };

  const cnterCompanies = props.companySearchResults.length;

  return (
    <div className={classNames("right_slide_block", { auto_fill_slide_step1: cnterCompanies === 0 }, { opnd: props.companySearchIsOpen })}>
      <div className="right_slide_block--inner">
        {cnterCompanies > 0 && (
          <HideResults onClick={companySearchTryAgain}>
            <FaWindowClose style={{ color: "#2f7de1" }} size="2em" />
          </HideResults>
        )}

        <div className="auto_fill_slide--content" style={{ position: "relative" }}>
          {cnterCompanies > 0 ? (
            <React.Fragment>
              <div className="company-search-top test_companySearchResults">
                <h2>
                  {props.domain.Strings.companySearchFoundTitlePre}
                  {" " + cnterCompanies + " "}
                  {props.domain.Strings.companySearchFoundTitlePost}
                </h2>
                <p>
                  <strong>{props.domain.Strings.companySearchFoundAnyMatch}</strong>
                  <br />
                  <span>{props.domain.Strings.companySearchFoundSelectRightMatch}</span>
                  <br />
                  <span>{props.domain.Strings.companySearchFoundNoneOfThese}</span>
                </p>
              </div>
              <div className="company-search-middle">
                <div className="company_matches">
                  {props.companySearchResults.map((r, index) => {
                    return <CompanyItem selectText={props.domain.Strings.companySearchSelectBtn} baseColour={props.domain.BaseColour} select={props.selectCompany} key={r.CompanyNumber} company={r} index={index} />;
                  })}
                </div>
              </div>
            </React.Fragment>
          ) : (
            <React.Fragment>
              <div className="test_companySearchNotFoundError">
                <h2>{props.domain.Strings.companySearchNoneFoundTitle}</h2>
                <p>{props.domain.Strings.companySearchNoneFoundExtra}</p>
                <div>
                  <a className="back_btn" onClick={companySearchReset}>
                    {props.domain.Strings.companySearchNoneFoundBackBtn}
                  </a>
                </div>
              </div>
            </React.Fragment>
          )}
        </div>
      </div>
      {cnterCompanies > 0 && props.companySearchFromTab !== "singleInvoiceCompany" && (
        <div className="company-search-bottom">
          <div className="bottom-btn">
            <a onClick={companySearchReset} className="back_btn">
              {props.domain.Strings.companySearchNoneOfTheseBtn}
            </a>
          </div>
        </div>
      )}
    </div>
  );
};

const mapStateToProps = state => {
  return {
    ...state.app
  };
};
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    resetCompanySearch: (tab, isTryAgain) => dispatch({ type: COMPANY_SEARCH_RESET, fromTab: tab, isTryAgain }),
    selectCompany: company => dispatch({ type: COMPANY_SEARCH_SELECTED, company: company })
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CompanySearch);

const HideResults = styled.div`
  position: absolute;
  top: 5px;
  &:hover {
    cursor: pointer;
  }
  right: 5px;
`;
